import { Col, Flex, List, Spin } from "antd";
import HeaderList from "../../HeaderList";
import BodyList from "../../BodyList";
import { useIntl } from "react-intl";
import dayjs from "dayjs";

const SummaryOfTransfers = ({ data, setPage, page, isLoading }: any) => {
  const intl = useIntl();
  const cols = [
    intl.formatMessage({ id: "saleNo" }), // for "sale_no"
    intl.formatMessage({ id: "client" }), // for "client"
    intl.formatMessage({ id: "salon" }), // for "client"
    intl.formatMessage({ id: "paymentDate" }), // for "payment_date"
    intl.formatMessage({ id: "paymentMethod" }), // for "payment_method"
    intl.formatMessage({ id: "paymentNo" }), // for "payment_no"
    intl.formatMessage({ id: "transactionType" }), // for "transaction_type"
    intl.formatMessage({ id: "paymentAmount" }), // for "payment_amount"
  ];
  console.log(data);

  const FormattedList = (data: any) => {
    return data?.data?.map((x: any) => {
      return {
        sale_no: x?.sale_no,
        client: x?.client,
        location: x?.location,
        payment_date: dayjs(x?.payment_date).format("DD-MM-YYYY HH:mm"),
        payment_method: x?.payment_method,
        payment_no: x?.payment_no,
        transaction_type: x?.transaction_type,
        payment_amount: x?.payment_amount,
      };
    });
  };

  return isLoading ? (
    <Spin className="flex items-center justify-center my-4" />
  ) : (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={FormattedList(data)}
        page={page}
        setPage={setPage}
        isLoading={isLoading}
      />
    </div>
  );
};

export default SummaryOfTransfers;
